/**
 * Lê um corpo SSE (`text/event-stream`) obtido via fetch e entrega cada evento completo ao
 * callback, remontando eventos partidos por fronteira de chunk de rede.
 *
 * Usado pelo canal de VOZ (`voice/stream`). O `converse/stream` mantém seu parser inline por
 * decisão deliberada: não tocar no caminho do texto, que está estável — unificar depois.
 *
 * Erro lançado pelo callback interrompe a leitura e propaga: quem chama sabe o que já foi
 * processado e decide o destino do turno.
 */
export async function lerEventosSse(
  body: ReadableStream<Uint8Array>,
  aoEvento: (evento: string, data: string) => void,
): Promise<void> {
  const reader = body.getReader();
  const decoder = new TextDecoder();
  let buffer = '';

  for (;;) {
    const { done, value } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    let idx: number;
    while ((idx = buffer.indexOf('\n\n')) >= 0) {
      const bloco = buffer.slice(0, idx);
      buffer = buffer.slice(idx + 2);
      const evento = /^event: (.+)$/m.exec(bloco)?.[1];
      const data = /^data: (.+)$/m.exec(bloco)?.[1];
      if (evento && data) aoEvento(evento, data);
    }
  }
}
